var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bookmarks" },
    [
      _c("h1", { staticClass: "bookmarks__title" }, [
        _vm._v("Meine Lesezeichen"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bookmarks__filters" }, [
        _c("input", {
          directives: [
            {
              name: "focus",
              rawName: "v-focus",
              value: _vm.focus,
              expression: "focus",
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.filter,
              expression: "filter",
            },
          ],
          staticClass: "bookmarks__filter bookmarks__filter--search",
          attrs: { placeholder: "Lesezeichen durchsuchen...", type: "search" },
          domProps: { value: _vm.filter },
          on: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              _vm.focus = false
            },
            click: function ($event) {
              _vm.focus = true
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.filter = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.magazine,
                expression: "magazine",
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.magazines.length,
                expression: "magazines.length",
              },
            ],
            staticClass: "bookmarks__filter bookmarks__filter--magazines",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.magazine = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { domProps: { value: undefined } }, [
              _vm._v("alle Magazine (" + _vm._s(_vm.bookmarksCount) + ")"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.magazines, function (magazine) {
              return _c(
                "option",
                {
                  key: magazine,
                  attrs: { disabled: !_vm.magazineHasBookmark(magazine) },
                  domProps: { value: magazine.url_name },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(magazine.screen_name) +
                      " (" +
                      _vm._s(_vm.magazineHasBookmark(magazine)) +
                      ")\n      "
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.fetching
        ? _c("spinner", { attrs: { message: "Lesezeichen werden geladen…" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.bookmarksAvailable
        ? _c(
            "transition-group",
            {
              staticClass: "bookmarks__list",
              attrs: { name: "list-complete", tag: "ul" },
            },
            _vm._l(_vm.filteredBookmarks(), function (bookmark) {
              return _c(
                "li",
                {
                  key: bookmark.id,
                  staticClass: "bookmarks__item list-complete-item",
                },
                [
                  _c("bookmark", {
                    attrs: {
                      bookmark: bookmark,
                      magazine: _vm.magazineForBookmark(bookmark),
                      deleted: bookmark.deleted,
                    },
                    on: {
                      restore: function ($event) {
                        return _vm.restore(bookmark)
                      },
                      remove: function ($event) {
                        return _vm.remove(bookmark)
                      },
                      save: function ($event) {
                        return _vm.save(bookmark)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.bookmarksAvailable && !_vm.fetching
        ? _c("p", [_vm._v("\n    Keine Lesezeichen vorhanden.\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.bookmarksAvailable && !_vm.filteredBookmarks().length && !_vm.fetching
        ? _c("p", [_vm._v("\n    Keine Suchergebnisse gefunden.\n  ")])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }